<template>
    <div>
        <div v-if="media_chan === 1 && (audience === 1 || audience === 2) && advertiserSectorsSet">
            <v-row id="product__rowpadding">
                <v-col :cols="4" class="label-field text-left no-right no-bottom">
                    Advertiser Address: 
                </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    {{advertiser_address}}
                </v-col>
            </v-row>
            <v-row id="product__rowpadding">
                <v-col :cols="4" class="label-field text-left no-right no-bottom">
                    Advertiser City: 
                </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                   {{advertiser_city}}
                </v-col>
            </v-row>
            <v-row id="product__rowpadding">
                <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom">
                    Advertiser State/Province:
                </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                {{advertiser_state_province}}
                   
                </v-col>
            </v-row>
            <v-row id="product__rowpadding">
                <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom">
                    Advertiser Zip/Postal Code:
                </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                {{advertiser_zipcode}}
                    
                </v-col>
            </v-row>
            <v-row id="product__rowpadding">
                <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom">
                    Advertiser Phone Number:
                </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                {{advertiser_phone}}
                    
                </v-col>
            </v-row>
            <v-row id="product__rowpadding">
                <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom">
                    Advertiser Url:
                </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                {{advertiser_url}}
                    
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'Advertiser',
    data: () => ({
        items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
    }),
    props : [
        "advertiserSectorsSet"
    ],
    computed: {
        ...mapGetters({
            states: "ProductData/getProductStates",
            media_chan: 'ProductData/getStateMediaChannel',
            audience: 'ProductData/getStateAudience',
        }),
            advertiser_address: {
                get: function() {
                    return this.$store.getters['ProductData/getAdvertiserAddress']
                },
                set: function(o) {
                    this.$store.dispatch('ProductData/setAdvertiserAddress', o)
                },
            },
            advertiser_city: {
                get: function() {
                    return this.$store.getters['ProductData/getAdvertiserCity']
                },
                set: function(o) {
                    this.$store.dispatch('ProductData/setAdvertiserCity', o)
                },
            },
            advertiser_state_province: {
                get: function() {
                    return this.$store.getters['ProductData/getAdvertiserState']
                },
                set: function(o) {
                    this.$store.dispatch('ProductData/setAdvertiserState', o)
                },
            },
            advertiser_zipcode: {
                get: function() {
                    return this.$store.getters['ProductData/getAdvertiserZipcode']
                },
                set: function(o) {
                    this.$store.dispatch('ProductData/setAdvertiserZipcode', o)
                },
            },
            advertiser_phone: {
                get: function() {
                    return this.$store.getters['ProductData/getAdvertiserPhone']
                },
                set: function(o) {
                    this.$store.dispatch('ProductData/setAdvertiserPhone', o)
                },
            },
            advertiser_url: {
                get: function() {
                    return this.$store.getters['ProductData/getAdvertiserUrl']
                },
                set: function(o) {
                    this.$store.dispatch('ProductData/setAdvertiserUrl', o)
                },
            },
    },
    methods: {
        // emit_delivery: function() {
        //     this.$emit('set', this.delivery)
        // }
    },
}
</script>